wbApp.controller('PicturesSelectDlgCtrl', ['$scope', '$timeout', '$modal', '$translate', 'picturesSvc',
function ($scope, $timeout, $modal, $translate, picturesSvc) {

    $scope.pictures = picturesSvc.getAllAsync(true);

    $scope.toggleSelected = function (picture) {
        picture.isSelected = !picture.isSelected;
    }

    $scope.detailIsUnchanged = function (pictures) {
        return !_.some(pictures, { isSelected: true });
    }

    $scope.onPicturesAdd = function (pictures) {

        if (!!$scope.onPicturesSelected) {
            $scope.onPicturesSelected(_.filter(pictures, { isSelected: true }));            
        }

        $scope.$hide();
    }

    $scope.onAddBtnClick = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.show();
            detailDialogPromise.$scope.onImageSave = function (imageUrl) {

                $scope.pictures = picturesSvc.getAllAsync(true);

                $scope.pictures.$promise.then(function() {
                    _.forEach(_.filter($scope.pictures, { imageUrl: imageUrl }), function (p) {
                        p.isSelected = true;
                    });
                });
            }
        });
    }

    var detailDialogPromise = $modal({
        templateUrl: 'storage/pictures/pictures-detail.html',
        show: false,
        scope: $scope
    });
}]);
